import Immutable, { Map } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { RESET_STORE } from 'constants/index'

// constants
export const TRANSLATION_JOB_WORKFLOW_TASK_FETCH_TABLE_DATA =
  'translations-job-workflow-task/TRANSLATION_JOB_WORKFLOW_TASK_FETCH_TABLE_DATA'
export const [
  TRANSLATION_JOB_WORKFLOW_TASK_FETCH_TABLE_DATA_SUCCESS,
  TRANSLATION_JOB_WORKFLOW_TASK_FETCH_TABLE_DATA_FAILURE,
] = [
  `${TRANSLATION_JOB_WORKFLOW_TASK_FETCH_TABLE_DATA}_SUCCESS`,
  `${TRANSLATION_JOB_WORKFLOW_TASK_FETCH_TABLE_DATA}_FAILURE`,
]
export const TRANSLATION_JOB_WORKFLOW_TASK_FETCH_FORM_DATA =
  'translations-job-workflow-task/TRANSLATION_JOB_WORKFLOW_TASK_FETCH_FORM_DATA'
export const [
  TRANSLATION_JOB_WORKFLOW_TASK_FETCH_FORM_DATA_SUCCESS,
  TRANSLATION_JOB_WORKFLOW_TASK_FETCH_FORM_DATA_FAILURE,
] = [
  `${TRANSLATION_JOB_WORKFLOW_TASK_FETCH_FORM_DATA}_SUCCESS`,
  `${TRANSLATION_JOB_WORKFLOW_TASK_FETCH_FORM_DATA}_FAILURE`,
]
export const TRANSLATION_JOB_WORKFLOW_TASK_CLEAR_STATE_LIST =
  'translations-job-workflow-task/TRANSLATION_JOB_WORKFLOW_TASK_CLEAR_STATE_LIST'
export const TRANSLATION_JOB_WORKFLOW_TASK_CLEAR_STATE_FORM =
  'translations-job-workflow-task/TRANSLATION_JOB_WORKFLOW_TASK_CLEAR_STATE_FORM'
export const TRANSLATION_JOB_WORKFLOW_TASK_CLEAR_STATE =
  'translations-job-workflow-task/CLEAR_STATE'
export const TRANSLATION_JOB_WORKFLOW_TASK_CHANGE =
  'translations-job-workflow-task/TRANSLATION_JOB_WORKFLOW_TASK_CHANGE'

// actions
export const translationsJobWorkflowTaskFetchTableData = ActionHelper.createActionObj(
  TRANSLATION_JOB_WORKFLOW_TASK_FETCH_TABLE_DATA,
)
export const translationsJobWorkflowTaskClearStateList = ActionHelper.createActionObj(
  TRANSLATION_JOB_WORKFLOW_TASK_CLEAR_STATE_LIST,
)
export const translationsJobWorkflowTaskClearState = ActionHelper.createActionObj(
  TRANSLATION_JOB_WORKFLOW_TASK_CLEAR_STATE_FORM,
)
export const translationsJobWorkflowTaskClearStateForm = ActionHelper.createActionObj(
  TRANSLATION_JOB_WORKFLOW_TASK_CLEAR_STATE,
)
export const translationsJobWorkflowTaskFetchFormData = ActionHelper.createActionObj(
  TRANSLATION_JOB_WORKFLOW_TASK_FETCH_FORM_DATA,
)
export const translationsJobWorkflowTaskChange = ActionHelper.createActionObj(
  TRANSLATION_JOB_WORKFLOW_TASK_CHANGE,
)

// store
const initialState = Immutable.fromJS({
  loading: true,
  tableData: {
    data: [],
    count: 0,
  },
  formData: {
    translations: [],
  },
})
const loadingActive = state => state.set('loading', true)

const jobWorkflowTaskTranslations = handleActions(
  {
    [combineActions(
      TRANSLATION_JOB_WORKFLOW_TASK_FETCH_TABLE_DATA_SUCCESS,
      TRANSLATION_JOB_WORKFLOW_TASK_CHANGE,
    )]: loadingActive,
    [combineActions(
      TRANSLATION_JOB_WORKFLOW_TASK_CLEAR_STATE,
      RESET_STORE,
    )]: () => initialState,
    [TRANSLATION_JOB_WORKFLOW_TASK_FETCH_TABLE_DATA_SUCCESS]: (state, action) =>
      state.set('tableData', Map(action.payload)),
    [TRANSLATION_JOB_WORKFLOW_TASK_FETCH_FORM_DATA_SUCCESS]: (state, action) =>
      state.set('formData', Map(action.payload)),
  },
  initialState,
)

export default jobWorkflowTaskTranslations
